export default __webpack_public_path__ + "static/media/tictactoe.02d53530.png";